import * as Comp from './switch.label.styles'

type SwitchLabelProps = {
  children: string
  disabled?: boolean
  testID?: string
}

export function SwitchLabel({ children, disabled, testID }: SwitchLabelProps) {
  const componentProperties = {
    hasDisabled: !!disabled,
  }

  return (
    <Comp.Label numberOfLines={1} testID={testID} {...componentProperties}>
      {children}
    </Comp.Label>
  )
}
